import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { PlusArchiveBetweenTheLines } from "./between-the-lines";
import { PlusArchiveChinaFutureTechBriefings } from "./china-future-tech-briefings";
import { PlusArchiveDailyPulse } from "./daily-pulse";
import { PlusArchiveFactSheet } from "./fact-sheet";
import { PlusArchiveInteractives } from "./interactives";
import { PlusArchiveOpenQuestionsSeries } from "./open-questions-series";
import { PlusArchiveQuickDigest } from "./quick-digest";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}
  margin-block-end: 40px;
  padding-block-start: 12px;
  padding-inline: 32px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  inline-size: 100%;
  max-inline-size: 1208px;
  margin: auto;
`;

export const StyledPlusArchiveDailyPulse = styled(PlusArchiveDailyPulse)`
  grid-area: daily-pulse;
`;

export const StyledPlusArchiveBetweenTheLines = styled(PlusArchiveBetweenTheLines)`
  grid-area: between-the-lines;
`;

export const StyledPlusArchiveFactSheet = styled(PlusArchiveFactSheet)`
  grid-area: fact-sheet;
`;

export const StyledPlusArchiveQuickDigest = styled(PlusArchiveQuickDigest)`
  grid-area: quick-digest;
`;

export const StyledPlusArchiveInteractives = styled(PlusArchiveInteractives)`
  grid-area: interactives;
`;

export const StyledPlusArchiveOpenQuestionsSeries = styled(PlusArchiveOpenQuestionsSeries)`
  grid-area: open-questions-series;
`;

export const StyledChinaFutureTechBriefings = styled(PlusArchiveChinaFutureTechBriefings)`
  grid-area: china-future-tech-briefings;
`;

export const SubWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px 40px;

  max-inline-size: 100%;

  ${theme.breakpoints.up("desktop")} {
    grid-template-columns:
      minmax(0, 1fr)
      minmax(0, 1fr)
      minmax(0, 1fr)
      minmax(0, 0.67fr);
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
`;
